import {Row, Col, Card, Typography, Divider, Space} from 'antd';
import Definition from '../../components/Definition';



const Terminology = () => {
    const contentIds = [
        '2SfYKTzUAzV7cFFmuqJeI9',
        '7l61s7ETqY4ZYTQhGsxaZG'
    ];

    return (
        <Row justify={'center'}>
            <Col flex={'0 0 800px'}>
                <Space direction={'vertical'} style={{width: '100%'}}>
                    {contentIds.map((contentId, index) => (
                        <div style={{borderBottom: '1px solid #ededed'}}>
                            <Definition key={index} contentId={contentId} />
                        </div>
                    ))}
                </Space>
            </Col>
        </Row>
    )
}

export default Terminology;